module.exports = __webpack_public_path__ + "static/media/banner2.d94460f0.jpeg";